import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae80032c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "线条样式：", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "线条颜色：", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "线条宽度：", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "起点样式：", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "终点样式：", -1))

import type { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTLineElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ElementShadow from '../common/ElementShadow.vue'
import ColorButton from '../common/ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Divider from '@/components/Divider.vue'
import NumberInput from '@/components/NumberInput.vue'
import Select from '@/components/Select.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LineStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleLineElement = handleElement as Ref<PPTLineElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateLine = (props: Partial<PPTLineElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: _unref(handleLineElement).style,
        "onUpdate:value": _cache[0] || (_cache[0] = value => updateLine({ style: value as 'solid' | 'dashed' })),
        options: [
          { label: '实线', value: 'solid' },
          { label: '虚线', value: 'dashed' },
        ]
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(handleLineElement).color,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = value => updateLine({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(handleLineElement).color
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(NumberInput, {
        value: _unref(handleLineElement).width,
        "onUpdate:value": _cache[2] || (_cache[2] = value => updateLine({ width: value })),
        style: {"width":"60%"}
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: _unref(handleLineElement).points[0],
        "onUpdate:value": _cache[3] || (_cache[3] = value => updateLine({ points: [value as 'arrow' | 'dot', _unref(handleLineElement).points[1]] })),
        options: [
          { label: '无', value: '' },
          { label: '箭头', value: 'arrow' },
          { label: '圆点', value: 'dot' },
        ]
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: _unref(handleLineElement).points[1],
        "onUpdate:value": _cache[4] || (_cache[4] = value => updateLine({ points: [_unref(handleLineElement).points[0], value as 'arrow' | 'dot'] })),
        options: [
          { label: '无', value: '' },
          { label: '箭头', value: 'arrow' },
          { label: '圆点', value: 'dot' },
        ]
      }, null, 8, ["value"])
    ]),
    _createVNode(Divider),
    _createVNode(ElementShadow)
  ]))
}
}

})